import { graphql } from "~/gql";

export const CREATE_LIBRARY_EXCLUSION = graphql(/* GraphQL */ `
  mutation CreateLibraryExclusion($data: LibraryExclusionCreateInput!) {
    createLibraryExclusion(data: $data) {
      id
      text
      mandatory
      default
      organisationalUnits {
        name
        id
      }
      createdAt
    }
  }
`);
